import React, { Component } from 'react';
import './PCBQtyValueRowReorderComponent.css';

const PCBQtyValueCell = (props) => {
    let styling = "pcb-qty-value-cell";
    if(props.selectedQty === props.item){
        styling = "pcb-qty-value-cell-checked";
    }

    return(
        <div className={styling} onClick={()=>props.itemOnClicked(props.item)}>
            {props.item}
        </div>
    );
};

class PCBQtyValueRow extends Component {
    constructor(props){
        super(props);
        this.state = {

        };

        this.itemOnClicked = this.itemOnClicked.bind(this);
    }

    itemOnClicked = (value) => {
        // console.log("value is : ",value);
        this.props.setReorderQty(value, "pcb");
    };

    render(){
        return(
            <div>
                {this.props.row.map((item) => {
                    return <PCBQtyValueCell
                        item = {item}
                        itemOnClicked = {this.itemOnClicked}
                        selectedQty = {this.props.selectedQty}
                    />
                })}

            </div>



        );

    }

}
export default PCBQtyValueRow;



// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderHistory/OrderItem/ReorderComponent/PCBQtyValueReorder/PCBQtyValueRowReorderComponent.js